export const adaptInsumosByIdTipoModulo = (insumo) => {
    return {
        idInsumoN: insumo?.idInsumoN,
        idInsumo: insumo?.idInsumo,
        description: insumo?.descripcion,
        genericDescription: insumo?.descripcion,
        quantity: insumo?.cantxDia,
        baseCalculateByDay: insumo?.cantxPack,
        alergias: insumo?.idAlergia?.map((alergia) => { return { id: alergia.idAlergia, displayName: alergia.descripcion } }),
        franjaEtarea: insumo?.idFranjaEtareaNavigation?.descripcion,
        unidad: insumo?.idUnidadNavigation?.descripcion,
        tipoAccesos: insumo?.idTipoAcceso?.map((tipoAcceso) => { return { id: tipoAcceso.idTipoAcceso, displayName: tipoAcceso.nombre } }),
    }
}
export const adaptInsumosByIdTipoModuloArray = (
    insumos
) => {
    return structuredClone(insumos?.allinsumosByIdTipoModulo?.items)
        ?.map(insumo => adaptInsumosByIdTipoModulo(insumo));
}